import { Injectable } from '@angular/core';

@Injectable()
export class AppService {

  constructor() { 
    
  }

  appsList: string[] = [];

  loadApp(appName: string) {    

    let isLoaded = this.appsList.indexOf(appName) != -1;
    if (!isLoaded) {
      localStorage.appsList = JSON.stringify(this.appsList.push(appName));
    }
  }

  getLoadedApps(): string[] {
    return this.appsList;
  }

  closeApp(appName: string){
    let index = this.appsList.indexOf(appName);
    this.appsList.splice(index, 1);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/app.service.ts